<template>
  <div class="template-data-grid-wrapper"
       :class="{'main-top-layout': topRoute}"
       v-loading="loading"
       element-loading-text="页面请求中，请稍等...">
    <template v-if="filters">
      <TemplateDataGridView ref="dataGridView"
                            :position="position"
                            :filters="filters"
                            v-bind="$attrs"
                            v-on="$listeners"></TemplateDataGridView>
    </template>
    <template v-else>
      <Hint class="meta-load-failed" :icon="false" v-if="!loading">
        <span>页面请求失败</span>
        <div class="button-group">
          <el-button type="primary" size="mini" plain @click="loadGridMeta">点击重试</el-button>
        </div>
      </Hint>
    </template>
  </div>
</template>

<script>
import baseApiUrl from '../../../constants/baseApiUrl'
import routeConfig from '../../../constants/routeConfig'
import TemplateDataGridView from './TemplateDataGridView'
import Hint from '../../elements/Hint'
import Support from '../../../mixins/support'
export default {
  name: 'TemplateDataGridWrapper',
  mixins: [Support],
  components: {
    TemplateDataGridView,
    Hint
  },
  data () {
    return {
      loading: false,
      position: null,
      filters: null
    }
  },
  methods: {
    loadGridMeta () {
      if (!this.loading) {
        let postParams = this.$extend(this.$attrs)
        if (!postParams[routeConfig.DataGrid.param]) {
          return
        }
        this.loading = true
        this.$ajax({
          url: baseApiUrl.DataGridUrl,
          method: 'post',
          headers: {
            'Api-Request-Mode': 'ApiMeta'
          },
          data: this.$qs.stringify(postParams, {
            arrayFormat: 'repeat'
          })
        }).then(response => {
          this.updateGridFilter(response.data)
        }).finally(() => {
          this.loading = false
        })
      }
    },
    updateGridFilter ({position, filters}) {
      if (position) {
        this.position = position
      }
      this.filters = filters || []
    },
    loadGridData () {
      const dataGridView = this.$refs['dataGridView']
      if (dataGridView) {
        dataGridView.loadGridData()
      }
    }
  },
  mounted () {
    this.loadGridMeta()
  },
  activated() {
    this.loadGridMeta()
  }
}
</script>

<style lang="scss">
.template-data-grid-wrapper {
  height: 100%;
  &.main-top-layout {
    padding: 10px;
  }
  .meta-load-failed {
    .button-group {
      margin: 10px auto;
      text-align: center;
      .el-button {
        padding: 5px 12px;
        border-radius: 0;
      }
    }
  }
}
</style>
